import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, Button as ButtonLegacy } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { DEFAULT_APP_NAME } from 'modules/constants'
import { changeApplication } from 'actions/rootActions'
import { setRedirectedAction, setAddOnUpgradeDismissed } from 'actions/planActions'
import { addOnOptions } from '../../Plan/planConfig'

interface Props {
  show?: boolean
  onHide?: () => void
}

/**
 * "Try Traffic & Advertising" upgrade gate. Rendered as the entire Traffic
 * page when the user lacks the add-on, and as an overlay from places like
 * the Reports builder when the user clicks the Traffic source type without
 * the add-on. When `onHide` is provided a close button is added so the
 * modal can be dismissed without leaving the page.
 */
export default function TrafficUpgradeModal({ show = true, onHide }: Props) {
  const dispatch = useDispatch()
  const addOnPrices = useSelector((state: any) => state.plan.addOnPrices)
  const prevAddOnNames = useSelector((state: any) => state.plan.prevAddOnNames) || []
  const addOnOptionConfigs = addOnOptions(addOnPrices)
  const trafficAddOnOption = addOnOptionConfigs.find((a: any) => a.product === 'Traffic')
  const mimicStatus = useSelector((state: any) => state.mimic.mimic.status)
  return (
    <div>
      <title>{`Traffic - ${DEFAULT_APP_NAME} Analytics & Intelligence`}</title>
      <Modal show={show} onHide={onHide} backdropClassName="backdrop-traffic plan-modal-backdrop" className="plan-modal">
        <Modal.Header closeButton={!!onHide}>
          <Modal.Title>Try Traffic & Advertising</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Start your 14 day free trial now.</h5>
          <ul style={{ listStyle: 'disc' }}>
            <li>Know what campaigns have great ROAS and improve your funnel performance.</li>
            <li> Compare traffic from all your marketing efforts and know what landing pages are performing best.</li>
            <li>Get the detail your team needs.</li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <div className="left">
            {mimicStatus ? (
              <div className="inline-block mr1">
                <ButtonLegacy
                  onClick={() => {
                    dispatch(setAddOnUpgradeDismissed({ Traffic: true }))
                  }}
                >
                  {'Continue'}
                </ButtonLegacy>
              </div>
            ) : null}
            <div className="float-right">
              <LinkContainer to={{ pathname: '/plan', search: 'view=add-ons' }}>
                <ButtonLegacy
                  variant="primary"
                  onClick={() => {
                    dispatch(changeApplication('traffic', 'plan'))
                    dispatch(setRedirectedAction({
                      targetApp: 'plan',
                      targetViewIndex: 1,
                      planOption: trafficAddOnOption,
                    }))
                  }}
                >
                  {prevAddOnNames?.includes('Traffic') ? 'Start Now' : 'Start Free Trial'}
                </ButtonLegacy>
              </LinkContainer>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
